<template>
  <div class="activity-item">
    <img v-lazy="data.cover"  alt="" class="cover" />
    <div class="activity_content">
      <div class="title">{{ data.title }}</div>
      <div class="content">{{ data.content }}</div>
      <router-link target="_blank" :to="{ path: '/activitydetail', query: { id: data.id } }" class="link">
        <img @click="navToActivityDetail" src="../../../../assets/img/btn.png" alt="立即参与" class="btn" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: Object,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    navToActivityDetail() {
      //
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.activity-item {
  margin-top: 60px;
  display: flex;
  align-items: center;
  .cover {
    width: 503px;
    height: 207px;
    object-fit: center;
  }
  .activity_content {
    flex: 1;
    margin-left: 43px;
    .title {
      color: #815a4e;
      font-size: 24px;
      font-weight: bold;
    }
    .content {
      font-size: 14px;
      line-height: 27px;
      margin: 10px 0;
      @include text-dot(3);
    }
    .btn {
      cursor: pointer;
    }
    // .link {
      // display: inline-block;
    // }
  }
}
</style>
